export const FIND_PAYMENT = 'PAYMENTS/find_payment';
export const UPDATE_TXN = 'PAYMENTS/update_txn';
export const TAG_FOR_POSTING = 'PAYMENTS/tag_for_posting';
export const VIEW_PAYMENT_LOGS = 'PAYMENTS/view_payment_logs';
export const VIEW_PAYMENT_LOGS_FOR_TXNID =
  'PAYMENTS/view_payment_logs_for_txnid';
export const POST_PAYMENT_TO_QPAX = 'PAYMENTS/post_payment_to_qpax';
export const MANUAL_EXPIRE_REFNO = 'PAYMENTS/manual_expire_refno';
export const APPROVE_REFUND = 'PAYMENTS/approve_refund';
export const VIEW_PAYMENT_LOGS_FOR_AMOUNT =
  'PAYMENTS/view_payment_logs_for_amount';
export const UPDATE_AMOUNT = 'PAYMENTS/update_amount';
export const CHANGE_YEAR = 'PAYMENTS/change_year';
export const UPDATE_QUARTER = 'PAYMENTS/update_quarter';
export const MANUAL_PAYMENT_APPROVE = 'PAYMENTS/manual_payment_approve';
export const MANUAL_PAYMENT_REJECT = 'PAYMENTS/manual_payment_reject';
export const UPDATE_REFERENCE_NUMBER = 'PAYMENTS/update_reference_number';
export const POST_EGOV_PAY = 'PAYMENTS/post_egov_pay';

export const GET_OFFICIAL_RECEIPTS = 'PAYMENTS/get_official_receipts';
export const GET_SINGLE_OFFICIAL_RECEIPT = 'PAYMENTS/show_official_receipt';
export const CREATE_OFFICIAL_RECEIPT = 'PAYMENTS/create_official_receipt';
export const UPDATE_OFFICIAL_RECEIPT = 'PAYMENTS/update_official_receipt';
export const REMOVE_OFFICIAL_RECEIPT = 'PAYMENTS/remove_official_receipt';
export const FINALIZE_OFFICIAL_RECEIPT = 'PAYMENTS/finalize_official_receipt';
export const MANUAL_PAYMENT_POSTING = 'PAYMENTS/manual_payment_posting';
export const ROLLBACK_PAYMENT = 'PAYMENTS/rollback_payment';
export const GET_FEE_OPTIONS = 'PAYMENTS/fee_options';
export const GET_FIND_PAYMENT_LIST = 'PAYMENTS/get_find_payment_list';
export const FIND_PAYMENT_BY_ID = 'PAYMENTS/find_payment_by_id';

export const MODULE_TYPES = [
  { label: 'BPLS', value: 'BPLS'},
  { label: 'CEDULA', value: 'CDL'},
  { label: 'CIVIL REGISTRY', value: 'LCR'},
];

export const TRANSACTION_STATUS = [
  { label: 'EXPIRED SOA', value: 'EXPIRED SOA'},
  { label: 'FOR PAYMENT CONFIRMATION', value: 'FOR PAYMENT CONFIRMATION'},
  { label: 'EXPIRED REFERENCE NUMBER', value: 'EXPIRED REFERENCE NUMBER'},
  { label: 'WAITING FOR PAYMENT', value: 'WAITING FOR PAYMENT'},
  { label: 'FOR PAYMENT', value: 'FOR PAYMENT'},
  { label: 'PAID', value: 'PAID'},
];

export const SORT_BY = [
  { label: 'ASCENDING', value: 'asc'},
  { label: 'DESCENDING', value: 'desc'},
];